import { connect } from 'react-redux';
import React, { Component } from 'react';

import {http_methods} from '../utils';
import {default_policy, prepare, submit} from '../request_client';

import md from 'markdown-it';
import md_checkbox from 'markdown-it-checkbox';
import markdown_style from 'github-markdown-css';

import {resolve_refs, strip_props, spec_validator} from '../spec_utils';
import yaml from 'js-yaml';

import MethodBadge from './MethodBadge';
import TagBadge from './TagBadge';
import SplitPanel from './SplitPanel';
import Pane from './Pane';
import DocView from './DocView';
import {Card, CardActions, CardHeader, CardText, FlatButton, Paper, Divider, TextField, SelectField, MenuItem, Dialog} from 'material-ui';
import {Tabs, Tab} from 'react-fe-bootstrap';

import _ from 'lodash';
import dv from 'validator';


const validators = {
  string: val => true,
  password: val => true,
  integer: dv.isInt,
  number: dv.isFloat,
  boolean: dv.isBoolean,
  null: dv.isNull,
  date: dv.isDate,
  email: dv.isEmail,
  host: dv.isFQDN,
  hostname: dv.isFQDN,
  ipv4: val => dv.isIP(val, 4),
  ipv6: val => dv.isIP(val, 6),
  uuid: dv.isUUID,
  mac: dv.isMACAddress,
  base64: dv.isBase64,
  url: dv.isURL,
  'date-time': dv.isISO8601
};

const RequestParamInput = ({name, schema, value, onChange, toggleTryItButton}) => {
  const required = schema.required || false;
  const init_value = value;

  const onChangeImpl = (event, index, value) => {
    if (value === undefined) {
      value = index;
    }

    if (value === '') {
      return onChange(value, required);
    }

    const type = schema.format || schema.type;
    const checker = validators[type];
    if (!checker) {
      log.warn('Unsupported format or type:', type);
      return;
    }

    const valid = checker(value.trim());
    if (!valid) {
      log.warn('Invalid value:', value, 'for type:', type);
      return onChange(value, required);
    }

    onChange(value, required);
  };

  if (schema.enum) {
    return <SelectField value={value} onChange={onChangeImpl} floatingLabelText={name} listStyle={{paddingTop: '0px', paddingBottom: '0px'}}>
      {schema.enum.map((val,idx) => <MenuItem key={idx} value={val} primaryText={val}/>)}
    </SelectField>;
  }

  const common_props = {
    floatingLabelText: name,
    value,
    onChange: onChangeImpl,
    required,
    fullWidth: true
  };

  if (required && (value === '' || value === null)) {
    common_props.errorText = 'This field is required';
    toggleTryItButton(false);
  } else if(value !== undefined) {
    const type = schema.format || schema.type;
    const checker = validators[type];
    const checked_val = value === undefined || value === null ? '' : value.toString ? value.toString() : '';
    if (checker && !checker(checked_val)) {
      common_props.errorText = `Invalid data for input type: ${type}`;
      toggleTryItButton(false);
    }
  }

  switch (schema.type) {
    case 'string':
      if (schema.format === 'email' || schema.format === 'date' || schema.format === 'time' || schema.format === 'password' || schema.format === 'url') {
        return <TextField type={schema.format} {...common_props}/>;
      }
      else {
        return <TextField type='text' {...common_props}/>;
      }
      break;
    case 'integer':
      return <TextField type='number' step='1'  {...common_props}/>;
      break;
    case 'number':
      return <TextField type='number' {...common_props}/>;
      break;
    default:
      return <TextField type='text' {...common_props}/>;
  }
};

const RequestParamsInput = type => ({schema, params = {}, onChange, toggleTryItButton}) => {
  if (!schema) return null;

  return <div>
    {Object.entries(schema).map(([name, schema]) =>
      <div key={name} style={{height: '80px', width: '350px', overflow: 'hidden', display: 'inline-block', paddingLeft: '10px', paddingRight: '10px'}}>
      <RequestParamInput
        key={name}
        name={name}
        value={params[name]}
        schema={schema}
        onChange={(value, required) => {
          onChange({[type]: {[name]: value}}, value, required);
        }}
        toggleTryItButton={value => {
          toggleTryItButton(value);
        }}
      />
      </div>
    )}
  </div>;
};

const RequestQueryParamsInput = RequestParamsInput('query');
const RequestHeadersInput = RequestParamsInput('header');
const RequestPathParamsInput = RequestParamsInput('path_param');

const null_validator = {
  allowed_props() {
    return {
      props: {},
      completions: {},
      values: []
    };
  },
  async validate() { return true; }
};

const RequestBodyInput = ({spec, method, path, body, onChange, schema: _schema, style}) => {
  if (!_schema) {
    const content = body ? yaml.dump(body) : '';
    return <DocView
      theme='base16-light'
      style={style}
      content={content}
      validator={null_validator}
      onValidatedChange={data => onChange({body: data.doc || data.raw})}
    />;
  }
  const fn = spec_validator.get_request_validator(spec, path, method);
  if (!fn) {
    const content = body ? yaml.dump(body) : '';
    return <DocView
      theme='base16-light'
      style={style}
      content={content}
      validator={null_validator}
      onValidatedChange={data => onChange({body: data.doc || data.raw})}
    />;
  }
  let schema = fn.schema;
  if (schema.$ref) {
    schema = spec_validator.lookup(schema.$ref).schema;
  }
  const schema_id = schema.id;

  const validator = {
    allowed_props(path) {
      //console.log(path, schema_id);
      return spec_validator.allowed_props(path, schema_id);
    },
    async validate(doc) { return fn(doc); },
    errors() { return fn.errors; }
  };

  const content = body ? yaml.dump(body) : '';
  return <DocView
    theme='base16-light'
    style={style}
    content={content}
    validator={validator}
    onValidatedChange={data => onChange({body: data.doc || data.raw})}
  />;
};

const BodySchemaView = ({spec, method, path, isResponse}) => {
  let fn = null;
  if(!isResponse) {
    fn = spec_validator.get_request_validator(spec, path, method);
  } else {
    fn = spec_validator.get_response_validator(spec, path, method);
  }
  if (!fn) return null;

  let schema = fn.schema;
  if (schema.$ref) {
    schema = spec_validator.lookup(schema.$ref).schema;
  }

  strip_props(schema, {
    __ctx: true
  });
  return <DocView
    renderOnce={true}
    theme='base16-light'
    content={yaml.dump(schema)}
    readOnly
    lineNumbers={false}
    lint={false}/>;
};


const background_style = {backgroundColor: '#fff'};

const get_renderer = () => {
  const inst = md({breaks: true}).use(md_checkbox);

  // https://github.com/markdown-it/markdown-it/blob/0e51825a5cd912121d733938ef2603833378888a/docs/architecture.md

  // Remember old renderer, if overriden, or proxy to default renderer
  const defaultRender = inst.renderer.rules.link_open || function(tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options);
  };

  inst.renderer.rules.link_open = function (tokens, idx, options, env, self) {
    // If you are sure other plugins can't add `target` - drop check below
    const aIndex = tokens[idx].attrIndex('target');

    if (aIndex < 0) {
      tokens[idx].attrPush(['target', '_blank']); // add new attribute
    }
    else {
      tokens[idx].attrs[aIndex][1] = '_blank';    // replace value of existing attr
    }

    // pass token to default renderer.
    return defaultRender(tokens, idx, options, env, self);
  };

  return inst;
};

const md_renderer = get_renderer();


const Authentication = props => {
  const {authentication} = props;
  return authentication ?
    <TagBadge className='api-info__tag bg-info' tag='Authenticated'/> :
    <TagBadge className='api-info__tag bg-info' tag='Unauthenticated'/>;
};

const Entitlements = props => {
  const {entitlements} = props;
  const label = 'Entitlements: ';
  return <span>
    {entitlements.map(entitlement => <TagBadge className='api-info__tag bg-info' key={entitlement} tag={entitlement}/>)}
  </span>;
};

const SecurityRequirements = props => {
  const {requirements} = props;
  return <span>
    <Authentication {...requirements}/>
    <Entitlements {...requirements}/>
  </span>;
};

const Routing = props => {
  const {inbound, outbound} = props;
  const in_port = inbound.port? `:${inbound.port}` : '';
  const base_url = `${inbound.protocol}://${inbound.host}${in_port}${inbound.prefix}`;
  return <TagBadge className='api-info__tag bg-info' tag={base_url}/>;
};

const Policy = ({policy}) => {
  const {security = {}, routing = {}} = policy;
  return <span>
    <SecurityRequirements {...security}/>
    <Routing {...routing}/>
  </span>;
};

class Examples extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0
    };
  }
  onChange(event, index, value) {
    this.setState({
      value
    });
    this.props.onChange && this.props.onChange(value === 0 ? {} : this.props.examples[value - 1]);
  }
  render() {
    const {examples} = this.props;
    if (!examples) return null;

    const data = [{
      summary: 'Examples',
      request: {
        body: null
      }
    }, ...examples];

    return <SelectField value={this.state.value} onChange={this.onChange.bind(this)} fullWidth={true} listStyle={{paddingTop: '0px', paddingBottom: '0px'}}>
      {data.map((example,idx) => <MenuItem key={idx} value={idx} primaryText={example.summary}/>)}
    </SelectField>;
  }
}

const Markdown = ({node}) => {
  if (!node.summary && !node.description) return null;

  const summary = node.summary || '';
  const description = node.description || '';
  const body = `#### ${summary}\n${description}`;
  return <div>
    <div className='markdown-body selectable' style={{paddingLeft: '10px'}} dangerouslySetInnerHTML={{__html: md_renderer.render(body)}}/>
    <br/>
  </div>;
};

const check_tags = (tags, filters, method) => {
  let tag_match = true;
  let method_match = false;
  let has_method = false;
  for (const filter of filters) {
    if (http_methods[filter]) {
      has_method = true;
      method_match = method_match || method === filter;
    }
    else {
      tag_match = tag_match && tags.indexOf(filter) !== -1;
    }
  }
  return tag_match && (has_method ? method_match : true);
};


const badgeStyle = {
  float: 'left',
  display: 'table-cell'
};

const Title = ({route, tags, parent_tags, ...props}) =>
  <div style={{display: 'table'}}>
    {props.children}
    <span style={{display: 'table-cell', margin: '2px', padding: '2px', verticalAlign: 'middle', minWidth: '300px'}}>{route}</span>
    {!tags ?
      null :
      <span style={{display: 'table-cell', width: '100%', verticalAlign: 'middle', textAlign: 'right'}}>
        {tags.map(tag => <TagBadge className='glow' key={tag} tag={`#${tag}`}/>)}
      </span>
    }
    {
      !parent_tags ?
      null :
      <span style={{display: 'table-cell', width: '100%', verticalAlign: 'middle', textAlign: 'right'}}>
        {parent_tags.map(tag => <TagBadge className='glow' key={tag} tag={`#${tag}`} style={{backgroundColor: '#ddffee'}}/>)}
      </span>
    }
  </div>;

const MethodTitle = ({method, ...props}) =>
  <Title {...props}>
    <MethodBadge method={method}/>
  </Title>;

class MethodImpl extends Component {
  constructor(props) {
    super(props);

    const {request = {}} = props.node;

    const query = Object.entries(request.query || {})
      .reduce((agg, [key, value]) => {
        agg[key] = value.default;
        return agg;
      }, {});

    const header = Object.entries(request.headers || {})
      .reduce((agg, [key, value]) => {
        agg[key] = value.default;
        return agg;
      }, {});

    const path_param = Object.entries(props.path_params || {})
      .reduce((agg, [key, value]) => {
        agg[key] = value.default;
        return agg;
      }, {});

    this.state = {
      valid: true,
      expanded: false,
      body: undefined,
      query,
      header,
      path_param,
      activeTabKey: 1
    };
    this.handleSelect = this.handleSelect.bind(this);
  }


  toggleExpansion() {
    this.setState({
      expanded: !this.state.expanded
    });
  }
  requestChanged(data, value, required) {
    if (_.has(data, 'body')) {
      data.valid = _.isObject(data.body);
    }

    this.setState(_.merge({}, this.state, data));

    if (required && (value === '' || value === null)){
      this.setState({valid: false}); // disabling the 'try it' button
    }
    else {
      this.setState({valid: true}); //enabling the 'try it' button
    }
  }
  //enables/disables the 'try it' button by setting the valid property of the state to true/false respectively
  toggleTryItButton(valid) {
    if (this.state.valid != valid){
      this.setState({valid});
    }
  }
  exampleSelected(example) {
    try {
      const new_state = {};
      const request = example.request || {};
      if (request.body) {
        new_state.body = request.body;
      }
      const params = request.params || {};
      if (params.headers) {
        new_state.header = params.headers;
      }
      if (params.query) {
        new_state.query = params.query;
      }
      if (params.path) {
        new_state.path_param = params.path;
      }
      this.setState(new_state);
    }
    catch(err) {
      this.setState({
        body: undefined
      });
    }
  }
  getBaseUrlFromPolicy() {
    const inbound = this.props.policy.routing.inbound;
    const in_port = inbound.port? `:${inbound.port}` : '';
    return `${inbound.protocol}://${inbound.host}${in_port}${inbound.prefix}`;
  }
  async requestSubmitted() {
    let route = this.props.path.join('');
    for (const [name, value] of Object.entries(this.state.path_param)) {
      route = route.replace(`:${name}`, value);
    }
    const base_url = this.props.edit_mode ? this.props.base_url : this.getBaseUrlFromPolicy();
    this.props.submitRequest({
      method: this.props.type,
      route,
      base_url,
      headers: this.state.header,
      query: this.state.query,
      body: this.state.body,
      path: this.props.path
    });
  }

  handleSelect(key) {
    this.setState({
      activeTabKey:key
    });
  }

  render() {
    const {type, path, spec, node, parent_tags, filters, policy, full_mode, route} = this.props;
    if (!check_tags(_.union(node.tags, parent_tags), filters, type)) { return null; }

    const path_param_schema = Object.entries(this.props.path_params || {})
      .reduce((agg, [key, value]) => {
        value.required = true;
        agg[key] = value;
        return agg;
      }, {});

    const header_schema = _.get(node, 'request.headers', null);
    const query_schema = _.get(node, 'request.query', null);
    const body_schema = _.get(node, 'request.body', null);
    const markdown = new md();
    let response_schema = _.get(node, 'response.body', null);
    if(response_schema && typeof response_schema === 'object') {
      response_schema = yaml.dump(response_schema);
    } else if(response_schema){
      response_schema = response_schema.split('/');
    }
    let error_schema = _.get(node, 'errors', null);
    if(error_schema && typeof error_schema === 'object') {
      error_schema = yaml.dump(error_schema);
    }
    return <div className="api-info" id={path.join('')+'-'+type}>
       <div className="api-info__head">
          <span className="api-info__head-method">{type}</span>
          <span className="api-info__head-title">{path.join('')}</span>
          <span className="api-info__head-sub-title"> | &nbsp; {node.summary}</span>
       </div>
       <div className="api-info__tags">
         <Policy policy={policy}/>
         { parent_tags.length > 0 ? parent_tags.map(tag => <TagBadge className='api-info__tag api-info__tag--bgcolor' tag={tag}/>):null }
       </div>
       {node.description && <div className="api-info__description" dangerouslySetInnerHTML={{__html:markdown.render(node.description)}}></div>}
       <Examples examples={node.examples} onChange={this.exampleSelected.bind(this)}/>
        {Object.keys(path_param_schema).length > 0 ?
          <Pane label='Path Parameters:'>
            <RequestPathParamsInput
              schema={path_param_schema}
              params={this.state.path_param}
              onChange={this.requestChanged.bind(this)}
              toggleTryItButton={this.toggleTryItButton.bind(this)}
            />
          </Pane> : null
        }
        {
          header_schema || query_schema || body_schema ?
          <div><a className="btn btn-primary" onClick={()=>this.setState({expanded:!this.state.expanded})}>{this.state.expanded?'Hide':'Show'} Schema</a> </div> : null
        }
        <div className="api-info__schema" style={{display:this.state.expanded?'block':'none'}}>
          {header_schema || query_schema ?
            <div className="api-info__schema-split-panel">
              <div className="api-info__schema-split-panel__div">
                <div className="api-info__schema-split-panel__div-title">HTTP Headers:</div>
                <RequestHeadersInput
                  schema={header_schema}
                  params={this.state.header}
                  onChange={this.requestChanged.bind(this)}
                  toggleTryItButton={this.toggleTryItButton.bind(this)}
                />
              </div>
              <div className="api-info__schema-split-panel__div">
                <div className="api-info__schema-split-panel__div-title">Query Parameters:</div>
                <RequestQueryParamsInput
                  schema={query_schema}
                  params={this.state.query}
                  onChange={this.requestChanged.bind(this)}
                  toggleTryItButton={this.toggleTryItButton.bind(this)}
                />
              </div>
            </div> : null
          }
          {
            body_schema ?
            <Divider/>:null
          }
          {body_schema ?
            <div className="api-info__schema-split-panel">
              <div className="api-info__schema-split-panel__div">
                <div className="api-info__schema-split-panel__div-title">Request Body:</div>
                <RequestBodyInput
                  method={type}
                  path={path}
                  style={{height: 'calc(100% - 37px)', width: 'calc(100%)'}}
                  spec={spec}
                  schema={_.get(node, 'request.body', null)}
                  body={this.state.body}
                  onChange={this.requestChanged.bind(this)}
                />
              </div>
              <div className="api-info__schema-split-panel__div">
                <Tabs activeKey = {this.state.activeTabKey} onSelect={this.handleSelect}>
                    <Tab eventKey={1} title="Request Schema">
                         {this.state.activeTabKey === 1 ? <BodySchemaView
                           method={type}
                           path={path}
                           spec={spec}
                         /> : null}
                    </Tab>
                    { response_schema ? <Tab eventKey={2} title="Response Schema">
                         {this.state.activeTabKey === 2 ? (!Array.isArray(response_schema) ? <DocView
                          renderOnce={true}
                          theme='base16-light'
                          content={response_schema}
                          readOnly
                          lineNumbers={false}
                          lint={false}/> : <BodySchemaView
                            method={type}
                            path={path}
                            isResponse={true}
                            spec={spec}/> ) : null}
                      </Tab> : null }
                    { error_schema ? <Tab eventKey={3} title="Errors">
                        {this.state.activeTabKey === 3 ? <DocView
                          renderOnce={true}
                          theme='base16-light'
                          content={error_schema}
                          readOnly
                          lineNumbers={false}
                          lint={false}/> : null}
                    </Tab> : null }
                </Tabs>

              </div>
            </div> : null
          }
          {
            (header_schema || query_schema || body_schema) ?
            <a onClick={this.requestSubmitted.bind(this)} style={{display:full_mode?'none':''}} disabled={!this.state.valid} className="btn btn-primary api-info__tryit">Try It!</a>  : null
          }
        </div>
        {
          !(header_schema || query_schema || body_schema) ?
          <a onClick={this.requestSubmitted.bind(this)} style={{display:full_mode?'none':''}} disabled={!this.state.valid} className="btn btn-primary api-info__tryit">Try It!</a>  : null
        }
    </div>;
  }
}

const Method = connect(
  state => ({
    base_url: state.getIn(['requests', 'base_url']),
    edit_mode: state.getIn(['apis', 'edit_mode']),
    full_mode: state.getIn(['apis', 'full_mode'])
  }),
  dispatch => ({
    async submitRequest(data) {
      const request = await prepare(data);
      dispatch({type: 'SUBMIT_REQUEST', data: request});
      const response = await submit(request);
      dispatch({type: 'RECEIVE_RESPONSE', data: response});
    }
  })
)(MethodImpl);

export default Method;
